<div [class.page]="!embedded()" [class.nm-embed]="embedded()">
  @if (!embedded()) {
    <div class="page-header">
      <div>
        <h1 class="page-title">{{ 'numberMatch.title' | translate }}</h1>
        <p class="page-sub">{{ 'numberMatch.sub' | translate }}</p>
      </div>
    </div>
  }

  <div [style.max-width]="embedded() ? 'none' : '920px'" style="margin:0 auto;width:100%">
    <div class="card">
      <div class="card-head">
        <div>
          <h3 class="card-title">{{ 'numberMatch.title' | translate }}</h3>
          <div class="card-sub">{{ 'numberMatch.cardSub' | translate }}</div>
        </div>
        <div class="row gap-6">
          <button class="btn sm" (click)="showHint()" [disabled]="won() || stuck()">
            <app-icon name="Info" [size]="13"></app-icon> {{ 'numberMatch.hint' | translate }}
          </button>
          <button class="btn sm primary" (click)="reset()">
            <app-icon name="Refresh" [size]="12"></app-icon> {{ 'numberMatch.newGame' | translate }}
          </button>
        </div>
      </div>

      <div class="card-pad-lg col gap-14">
        <div class="nm-stats">
          <div class="nm-stat"><div class="nm-stat-l">{{ 'numberMatch.score' | translate }}</div><div class="nm-stat-v mono">{{ fmt(score()) }}</div></div>
          <div class="nm-stat"><div class="nm-stat-l">{{ 'numberMatch.best' | translate }}</div><div class="nm-stat-v mono">{{ fmt(best()) }}</div></div>
          <div class="nm-stat"><div class="nm-stat-l">Agency best</div><div class="nm-stat-v mono">{{ agencyBestLabel() }}</div><div class="muted text-tiny">{{ agencyBestOwner() || 'No score yet' }}</div></div>
          <div class="nm-stat"><div class="nm-stat-l">{{ 'numberMatch.combo' | translate }}</div><div class="nm-stat-v mono">{{ combo() > 0 ? '×' + combo() : '—' }}</div></div>
          <div class="nm-stat"><div class="nm-stat-l">{{ 'numberMatch.onBoard' | translate }}</div><div class="nm-stat-v mono">{{ remaining() }}</div></div>
        </div>

        @if (won()) {
          <div class="nm-banner win">
            <app-icon name="Star" [size]="15"></app-icon> {{ 'numberMatch.win' | translate }}
            <button class="btn sm primary" (click)="reset()" style="margin-inline-start:auto">{{ 'numberMatch.playAgain' | translate }}</button>
          </div>
        }
        @if (stuck()) {
          <div class="nm-banner stuck">
            <app-icon name="Info" [size]="15"></app-icon> {{ 'numberMatch.stuck' | translate }}
            <button class="btn sm" (click)="addNumbers()" style="margin-inline-start:auto"><app-icon name="Plus" [size]="12"></app-icon> {{ 'numberMatch.addNumbers' | translate }}</button>
          </div>
        }

        <div class="nm-wrap">
          <div class="nm-board" [style.grid-template-columns]="'repeat(' + cols + ', 1fr)'">
            @for (v of cells(); track $index) {
              <button [class]="cellClass($index, v)" [style.--c]="v ? 'var(--nm' + v + ')' : null"
                      (click)="click($index)" [disabled]="v === null">{{ v }}</button>
            }
          </div>
          @if (flash(); as f) { <div class="nm-flash">+{{ f.pts }}</div> }
        </div>

        <div class="row gap-8" style="flex-wrap:wrap;align-items:center">
          <button class="btn sm" (click)="addNumbers()" [disabled]="won()">
            <app-icon name="Plus" [size]="12"></app-icon> {{ 'numberMatch.addNumbers' | translate }}
            <span class="muted" style="margin-inline-start:4px">({{ remaining() }})</span>
          </button>
          <div class="nm-legend">
            @for (n of digits; track n) {
              <span class="nm-chip filled" [style.--c]="'var(--nm' + n + ')'">{{ n }}</span>
            }
          </div>
        </div>

        @if (!embedded()) {
          <div class="callout-soft nm-rules" [innerHTML]="'numberMatch.rules' | translate"></div>
        }
      </div>
    </div>
  </div>
</div>
